"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      transition: theme.transitions.create("width")
    },
    suggestionsContainer: {
      position: "absolute",
      left: "2px",
      right: "2px",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0",
      borderTop: "0",
      overflow: "hidden"
    },
    container: {
      position: "relative",
      zIndex: 5
    },
    suggestion: {
      cursor: "pointer",
      padding: theme.spacing(2),
      color: theme.palette.text.primary
    },
    suggestionHighlighted: {
      background: theme.palette.action.selected,
      color: theme.palette.text.primary
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyle: "none"
    },
    outerWrapper: {
      width: "100%"
    }
  };
};

exports.styles = styles;